import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegisterInforService } from '@pg-app/auth/services/register-infor.service';
import { RegisterStep1Service } from '@pg-app/auth/services/register-step-1.service';
import { AuthService } from '@pg-app/core/services/auth.service';
import { StoreProvider } from '@pg-app/core/services/storeProvider/store.provider';
import { VerifyCodeErrorEnum } from '@nttp/enum/verify-code-error-type.enum';
import { AuthyTicketTypeEnum } from '@nttp/enum/authy-ticket-type.enum';
import { VerifyTypeSendCodeEnum } from '@nttp/enum/verify-type.enum';
import { ShareService } from '@nttp/common-service/share-service';

@Component({
  selector: 'np-verify-passcode',
  templateUrl: './verify-passcode.component.html',
  styleUrls: ['./verify-passcode.component.scss']
})
export class VerifyPasscodeComponent implements OnInit {
  clientId = '';
  userId = '';

  btnName = 'Sign in';
  pinCodeError = null;
  email = '';
  ticketType = AuthyTicketTypeEnum.RegisterAccount;
  sendOnetouchSuccess = false;

  constructor(
    private router: Router,
    public registerInfor: RegisterInforService,
    private registerStep1Service: RegisterStep1Service,
    private authService: AuthService,
    private store: StoreProvider,
    private shareService: ShareService
  ) {}

  ngOnInit() {
    this.clientId = this.registerInfor.clientId;
  }

  exceedInvalidCode() {
    this.router.navigate(['auth/register/alternative-receive-code']);
  }

  login(event = null) {
    this.pinCodeError = null;
    this.registerStep1Service
      .verifyCode({
        userId: this.registerInfor.userId,
        clientId: this.registerInfor.clientId,
        verificationCode: event ? event.code : null,
        verificationType: event ? event.verificationType : VerifyTypeSendCodeEnum.Onetouch,
        portalId: this.registerInfor.portalId,
        tokenHash: this.registerInfor.tokenHash
      })
      .subscribe(
        res => {
          this.store.set('accessToken', res.token);
          this.store.set('refreshToken', res.refreshToken);
          this.store.set('tokenType', res.tokenType);
          this.store.set('userId', res.userId);
          this.store.set('clientId', res.clientId);
          this.store.set('portalTypes', res.portalTypes);

          this.authService.accessToken = this.store.get('accessToken');
          this.authService.tokenType = this.store.get('tokenType') || 'Bearer';
          this.authService.refreshToken = this.store.get('refreshToken');
          this.authService.userId = this.store.get('userId');
          this.authService.clientId = this.store.get('clientId');

          if (
            this.registerInfor.customerType === 2 ||
            (this.registerInfor.customerType === 4 && this.registerInfor.parentType === 2)
          ) {
            this.shareService.accountType$.subscribe(data => {
              if (data.isStep2Completed) {
                this.router.navigate(['/partner', 'dashboard']);
              } else {
                this.router.navigate(['/partner/register/step-2']);
              }
            });
          } else {
            this.router.navigate(['client/dashboard']);
          }
        },
        error => {
          this.pinCodeError = VerifyCodeErrorEnum.InvalidCode;
        }
      );
  }

  sendCode(event = null) {
    this.pinCodeError = null;
    const params = {
      tokenHash: this.registerInfor.tokenHash,
      verificationType: event ? event.method : VerifyTypeSendCodeEnum.Authy,
      ticketType: AuthyTicketTypeEnum.RegisterAccount
    };
    this.registerStep1Service.resendPassCode(params).subscribe(
      res => {
        if (event && event.isTryAgain) {
          this.pinCodeError = VerifyCodeErrorEnum.ResendCode;
        }
        if (!event) {
          this.sendOnetouchSuccess = true;
        }
      },
    );
  }
}
